import React from 'react'
import Associations from '../../associations'

const fields = [{
  name: 'User',
  prop: 'user_id',
  type: 'autocomplete',
  references: 'admin/users',
  referenceProp: 'fullname',
  displayProp: 'name'
}]

const columns = [
  { name: 'ID', prop: 'id' },
  { name: 'Name', prop: 'name' },
  { name: 'Email', prop: 'email' }
]

const SubAccounts = ({ params }) => (
  <Associations
// @ts-ignore
    title='Account Holders'
    fields={fields}
    columns={columns}
    baseRecord={{
      institution_id: params.institutionId,
      is_account_holder: true
    }}
    joinApiPath='admin/institution_users'
    associationApiPath='admin/users'
    joinApiQuery={{
      'filters[institution_id]': params.institutionId,
      'filters[is_account_holder]': true
    }}
    associationIdField='user_id'
  />
)

export default SubAccounts
